import { useEffect } from "react";

/**
 * Inject (and clean up) a JSON-LD <script> tag in <head> for SEO.
 * Pass a JS object; component handles serialization, identification and
 * removal on unmount or when the data changes.
 */
export default function JsonLd({ id, data }) {
  useEffect(() => {
    if (!data) return;
    const elId = `jsonld-${id || "default"}`;
    let el = document.getElementById(elId);
    if (!el) {
      el = document.createElement("script");
      el.type = "application/ld+json";
      el.id = elId;
      document.head.appendChild(el);
    }
    try {
      el.textContent = JSON.stringify(data);
    } catch {
      // ignore
    }
    return () => {
      const node = document.getElementById(elId);
      if (node && node.parentNode) node.parentNode.removeChild(node);
    };
  }, [id, data]);
  return null;
}
